import asyncSeries from 'async/series';
import util from './util';

export default {
  init,
  login,
  loginWithToken,
};

function init() {}

function login(done) {
  const player_info: any = {};
  const is_instagram = window.navigator.userAgent.indexOf('Instagram') !== -1;
  asyncSeries(
    [
      done => {
        if (is_instagram) {
          const redirect_uri = encodeURIComponent(
            `https://${window.location.host}/fb_login_complete`
          );
          let url = 'https://www.facebook.com/v6.0/dialog/oauth';
          url += `?client_id=${process.env.WEB_FB_APP_ID}`;
          url += `&redirect_uri=${redirect_uri}`;
          url += '&response_type=token';
          window.location.href = url;
          setTimeout(() => done('timeout'), 5000);
        } else if (window.FB) {
          const opts = { scope: 'email' };
          window.FB.login(response => {
            let err;
            if (response && response.status === 'connected') {
              player_info.uid = response.authResponse.userID;
              player_info.access_token = response.authResponse.accessToken;
            } else {
              err = 'not_logged_in';
            }
            done(err);
          }, opts);
        } else {
          util.errorLog('facebook.login: error no window.FB');
          done('no_fb_sdk');
        }
      },
      done => {
        _getInfo(null, (err, info) => {
          Object.assign(player_info, info);
          done(err);
        });
      },
    ],
    err => {
      done(err, player_info);
    }
  );
}

function loginWithToken(access_token: string, done) {
  const player_info: any = {
    access_token,
  };
  _getInfo(access_token, (err, info) => {
    if (!err) {
      Object.assign(player_info, info);
      player_info.uid = player_info.id;
    }
    done(err, player_info);
  });
}

function _getInfo(access_token: string | null, done) {
  const fields = 'id,email,name,picture.type(large)';
  const opts: any = {
    fields,
  };
  if (access_token) {
    opts.access_token = access_token;
  }
  window.FB.api('/me', 'get', opts, response => {
    let err;
    let data;
    if (!response || response.error) {
      console.error('FB login failed:', response);
      err = 'sdk_not_logged_in';
    } else {
      data = {
        id: response.id,
        email: response.email,
        name: response.name,
        photo_url: _getUrl(response.picture),
      };
    }
    done(err, data);
  });
}

function _getUrl(obj: any) {
  return obj && obj.data && obj.data.url;
}
